<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <el-form-item
        label="名称"
        prop="name"
        :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
      >
        <el-input v-model="state.model.name"></el-input>
      </el-form-item>
      <ul class="items-center gap-x-3 grid grid-cols-2">
        <el-form-item
          label="日期"
          prop="date"
          :rules="[{ required: true, message: '请选择日期', trigger: 'blur' }]"
          style="min-width: 0"
        >
          <el-date-picker
            v-model="state.model.date"
            type="date"
            placeholder="--请选择--"
            value-format="YYYY-MM-DD"
            disabled
          />
        </el-form-item>
        <el-form-item
          label="时间"
          prop="times"
          :rules="[{ required: true, message: '请选择时间', trigger: 'blur' }]"
          style="min-width: 0"
        >
          <el-time-picker
            v-model="state.model.times"
            is-range
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="HH:mm:ss"
            format="HH:mm"
            :default-value="[
              new Date().setHours(8, 0, 0),
              new Date().setHours(18, 0, 0),
            ]"
            :save-on-blur="false"
          />
        </el-form-item>
      </ul>
      <el-form-item label="说明">
        <el-input v-model="state.model.intro" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  meeting_agenda_detail,
  meeting_agenda_add,
  meeting_agenda_edit,
} from "@/http/meeting";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    meeting_id: Number,
    meeting_schedule_id: Number,
    meeting_schedule_date: String,
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        meeting_id: props.meeting_id,
        meeting_schedule_id: props.meeting_schedule_id,
        date: props.meeting_schedule_date,
      },
    });
    onMounted(() => {
      onLoadDetail();
    });

    //加载详情
    const onLoadDetail = () => {
      if (props.id) {
        meeting_agenda_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            state.model.times = [data.start_time, data.end_time];
          }
        });
      }
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (state.model.times?.length == 2) {
            state.model.start_time = state.model.times[0];
            state.model.end_time = state.model.times[1];
          }
          if (props.id) {
            meeting_agenda_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            meeting_agenda_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onLoadDetail,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
